import React from 'react';
import { List, Box, ListItem, ListItemIcon, ListItemText } from '@material-ui/core';
import CheckIcon from '@material-ui/icons/Check';
import classes from './Sorter.module.scss';

const SORTERS = [
  {
    key: 'asc',
    label: 'A to Z',
  },
  {
    key: 'desc',
    label: 'Z to A',
  },
];
const SorterByName = ({ value, onChange }) => {
  const [sorter, setSorter] = React.useState({});

  const handleChangeSort = ({ key, label }) => () => {
    setSorter({ key, label });
    onChange({ key, label });
  };

  React.useState(() => {
    const newSorter = SORTERS.find(({ key }) => key === value);
    setSorter(newSorter || {});
  }, [value]);

  return (
    <Box className={classes.wrapper}>
      <Box maxHeight='350px' overflow='scroll'>
        <List>
          {SORTERS.map(({ key, label }) => (
            <ListItem
              className={classes.item}
              key={key}
              dense
              button
              onClick={handleChangeSort({ key, label })}>
              <ListItemIcon>{sorter?.key === key && <CheckIcon />}</ListItemIcon>
              <ListItemText primary={label} />
            </ListItem>
          ))}
        </List>
      </Box>
    </Box>
  );
};
export default SorterByName;
